export default {
  data() {
    return {
      modalConfirmTitle: null,
      modalConfirmText: null,
      modalConfirmAction: null,
      modalConfirmItem: null,
      showConfirm: false,
    }
  },
  methods: {
    duplicateItem(item) {
      this.modalConfirmTitle = 'Dokumento kūrimas'
      this.modalConfirmText =
        'Ar norite kurti dokumentą šio dokumento pagrindu?'
      this.modalConfirmAction = 'Duplicate'
      this.modalConfirmItem = item
      this.showConfirm = true
    },
    confirmDuplicate(item) {
      this.loading = true

      const data = {
        obj_id: item.obj_id,
      }

      this.$axios
        .post(`objektas/${item.obj_id}/pagrindas`, data)
        .then(res => {
          let objektasID = res.data.objektas.obj_id
          this.$store.dispatch('objektasID', objektasID)
          this.$router.push({
            name: 'hipotekaPranesimas',
            params: {
              objektasID: objektasID,
            },
          })
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    closeConfirm() {
      this.showConfirm = false
    },
  },
}
